export const ESTIMATE_DELIVERY_FLAG = {
  ACTIVE: 1,
  INACTIVE: 0,
};
